import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../modules/auth/hooks/useAuth";
import Loader from "../components/common/Loader";

const ProtectedRoute = () => {
  const {
    user,
    isAuthenticated,
    loading,
  } = useAuth();

  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
        }}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;